<template>
    <main>
       <div class="row no-gutters">
            <div class="form-group col-lg-4 col-sm-4  pl-2 mt-4" v-for="item in $v.examenPies.$each.$iter" :key="item.id">
            <label  class="mb-0"> {{item.nombre.$model}} </label>
                <textarea class="form-control" v-model="item.detalle.$model" :class="{'is-invalid':item.detalle.$error}"></textarea>
            </div>
        </div>
        <button class="btn btn-success" @click="guardar()">Guardar</button>
    </main>
</template>
<script>
import {required} from "vuelidate/lib/validators";
import partesExamenPiesService from "../../../../services/partesExamenPiesService";
import historiaExamenPiesService from "../../../../services/historiaExamenPiesService";
import {isEmpty} from 'lodash';
import Toast from '../../../../components/common/utilities/toast';
export default {
    props:['idHistoria','finalizada'],
    data(){
        return {
            control_historia_examen:false,
            examenPies:[],
        }
    },
    validations (){
        return {
            examenPies:{
                $each:{
                    nombre:{required},
                    detalle:{required}
                }
            }
        }
    },
    methods:{
        validate(){
            this.$v.$touch();
        },
        async guardar(){
            try{
                this.$v.$touch();

                if(this.$v.$invalid) return false;

                let revision ={
                    id_historia:this.idHistoria,
                    partes:this.examenPies,
                }

                this.LoaderSpinnerShow();
                if(this.control_historia_examen){
                    await historiaExamenPiesService.update(revision);
                    this.control_historia_examen=true;
                }else{
                    await historiaExamenPiesService.store(revision);
                    this.control_historia_examen=true;
                }
                
                this.LoaderSpinnerHide();

                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con exito'
                });
                
            } catch (error) {
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            } 
            
        },
        async cargarHistoriaExamen(){
            const response = await partesExamenPiesService.index();
            this.examenPies= response.data.map(x=>{
                return {
                    ...x,
                    detalle:'NORMAL'
                }
            });
        },
    },
    watch:{
        finalizada: async function (value){
            if(value==='N'){
                 const response = await historiaExamenPiesService.showByHc(this.idHistoria);
                if(!isEmpty(response.data)){
                     this.control_historia_examen=true;
                     response.data.forEach(x=>{
                        let i = this.examenPies.findIndex(p => parseInt(p.id) === parseInt(x.id_parte));
                        if(i!==-1)  this.examenPies[i].detalle = x.detalle;
                    });
                    
                }
            } 
        }
    },
    async created(){
        await this.cargarHistoriaExamen();
        if(this.finalizada==='N'){
            const response = await historiaExamenPiesService.showByHc(this.idHistoria);
            if(!isEmpty(response.data)){
                    this.control_historia_examen=true;
                    response.data.forEach(x=>{
                    let i = this.examenPies.findIndex(p => parseInt(p.id) === parseInt(x.id_parte));
                    if(i!==-1)  this.examenPies[i].detalle = x.detalle;
                });
            }
        }
    }
}
</script>